"use client"

import { BookCheck } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BookCheckIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BookCheckIcon = component(Icon)({ as: BookCheck })
